import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'

const scrollRestorationSiteConfig: SiteConfigFn<Record<string, never>> = () => {
	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'scrollRestoration'

export const config = { site: scrollRestorationSiteConfig, reactRendererSite: scrollRestorationSiteConfig, name }
